import { getBlockNameByType } from 'lib/blocks';

import type { LocaleMessages, Theme } from 'shared-types';
import type { EditorBlockTypes } from 'types';

interface Props {
  blockType?: EditorBlockTypes;
  fontSize: 'small' | 'medium' | 'large' | 'huge';
  isMandatory?: boolean;
  messages: LocaleMessages;
  style?: React.CSSProperties;
  theme: Pick<Theme, 'textColorLight' | 'textColorLighter'>;
  title?: string;
}

const ReaderTaskHeader = ({
  blockType,
  fontSize,
  isMandatory,
  messages,
  style,
  theme,
  title
}: Props) => (
  <div
    className="header"
    style={{
      fontSize: {
        small: '1.2rem',
        medium: '1.3rem',
        large: '1.4rem',
        huge: '1.6rem'
      }[fontSize],
      ...style
    }}
  >
    {title
      ? title
      : blockType
      ? getBlockNameByType({ messages, type: blockType })
      : null}

    {isMandatory ? (
      <span>
        {title || blockType ? <span className="divider">{'•'}</span> : null}
        <span className="mandatory">{messages.commonMandatory}</span>
      </span>
    ) : null}

    <style jsx>{`
      .header {
        color: ${theme.textColorLight};
        font-size: 1.4rem;
        font-weight: 600;
        margin: -3px 0 10px;
      }
      .divider {
        margin: 0 5px;
      }
      .mandatory {
        color: ${theme.textColorLighter};
        font-weight: 400;
      }
    `}</style>
  </div>
);

export default ReaderTaskHeader;
